"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsMainSidebarOption = void 0;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactProSidebar = require("react-pro-sidebar");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsMainSidebarOption component represents an option in the main sidebar menu.
 * @param {Object} props - Component props.
 * @param {string} props.title - The title or label for the sidebar option.
 * @param {React.ReactNode} props.icon - The icon to display alongside the title.
 * @param {string} props.route - The route or URL to navigate to when the option is clicked.
 * @param {boolean} props.collapsed - Whether the sidebar is collapsed or expanded.
 * @returns {JSX.Element} DmsMainSidebarOption component.
 *
 * @example
 * <DmsMainSidebarOption
 *   title={intl.get("Users").d("Users")}
 *   icon={<UserIcon />}
 *   route={ROUTES.User}
 *   collapsed={collapsed}
 * />
 */
const DmsMainSidebarOption = _ref => {
  let {
    title,
    icon,
    route,
    collapsed
  } = _ref;
  const theme = (0, _material.useTheme)();
  const location = (0, _reactRouterDom.useLocation)();
  if (collapsed && !icon) return null;
  return /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    title: title,
    arrow: true,
    placement: "right"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactProSidebar.MenuItem, {
    active: location.pathname === route,
    icon: icon,
    component: /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: route
    }),
    style: {
      paddingLeft: collapsed ? "16vw" : "auto"
    }
  }, !collapsed && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2",
    style: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "180vw"
    }
  }, title))));
};
exports.DmsMainSidebarOption = DmsMainSidebarOption;